import { PreferencesLoadingErrorModal } from 'components/Blotters/PriceImprovement/preferencesLoadingErrorModal';
import { ConnectedPriceImprovementBlotter } from 'components/Blotters/PriceImprovement/PriceImprovementBlotter';
import { FC } from 'react';

const PriceImprovementBlotter: FC = () => (
  <div className="price-improvement-blotter-route-component page-container w-100 h-100">
    <PreferencesLoadingErrorModal>
      <ConnectedPriceImprovementBlotter />
    </PreferencesLoadingErrorModal>
  </div>
);

export default PriceImprovementBlotter;
